<div class="pm-full-size">
  <pm-logo (watermarkClicked)="deactivate()"></pm-logo>
  <pm-toolbars (menuClicked)="menuClicked()">
  </pm-toolbars>

  <mat-sidenav-container [class.iOS]="isIOS">
    <mat-sidenav mode="over" #navMenu>
      <h3 class="proman-user-name">{{ getUserFullName(user$ | async) }}</h3>
      <mat-nav-list>
        @if (online | async) {
          @if ((canChangePassword | async)) {
            <a mat-list-item (click)="changePasswordClick()">{{'dialog.password-change.title' | translate}}</a>
          }
          @if (isUserAdmin(user$ | async)) {
            <a mat-list-item (click)="userAdminClick()">{{userAdminTitleKey | translate}}</a>
          }
          @if (isAdmin(user$ | async)) {
            <a mat-list-item (click)="languageAdminClick()">{{'dialog.language-admin.title' | translate}}</a>
          }
          @if (isAdmin(user$ | async)) {
            <a mat-list-item (click)="labelAdminClick()">{{'dialog.label-admin.title' | translate}}</a>
          }
          @if (isAdmin(user$ | async) && isVendor) {
            <a mat-list-item (click)="templateAdminClick()">{{'dialog.template-admin.title' | translate}}</a>
          }
          @if (isAdmin(user$ | async) && isPurchase) {
            <a mat-list-item (click)="subscriptionAdminClick()">{{'dialog.subscription.title' | translate}}</a>
          }
          @if (isAdmin(user$ | async) && isTrial) {
            <a mat-list-item [href]="buyNowLink" target="_blank">{{'main.subscription.buy' | translate}}</a>
          }
          @if (isAdmin(user$ | async)) {
            <a mat-list-item [matMenuTriggerFor]="reportMenu">{{'main.reports' | translate}}</a>
          }
          <mat-menu #reportMenu="matMenu" xPosition="after">
            @if (isAdmin(user$ | async)) {
              <a mat-menu-item (click)="ownerReportClick()">{{'dialog.owner-report.title' | translate}}</a>
            }
            @if (isAdmin(user$ | async)) {
              <a mat-menu-item (click)="permissionReportClick()">{{'dialog.permissions-list.title' | translate}}</a>
            }
            @if (isAdmin(user$ | async)) {
              <a mat-menu-item (click)="linkCheckClick()">{{'dialog.link-check.title' | translate}}</a>
            }
            @if (isAdmin(user$ | async)) {
              <a mat-menu-item (click)="openStatistics()">{{'dialog.statistics.title' | translate}}</a>
            }
          </mat-menu>
          @if (hasSiteMap) {
            <a mat-list-item (click)="openSiteMap()">{{'main.sitemap' | translate}}</a>
          }
          <a mat-list-item (click)="openNonconformity()">{{'main.nonconformity' | translate}}</a>
          <hr>
            @if (isModernSubscriptionType) {
              <a mat-list-item (click)="onEditMappings()">{{'dialog.edit-template-mappings.title' | translate}}</a>
            }
            @if (showImageOption$ | async) {
              <a mat-list-item (click)="onEditLogoClick()">{{'menu.toolbar.edit-logo-watermark' | translate}}</a>
            }
          }

          <a mat-list-item [href]="helpUrl((currentLanguage | async))" target="_blank">{{'menu.toolbar.help' | translate}}</a>

        </mat-nav-list>
        @if (offlineEnabled) {
          <div class="offline-options mat-typography">
            <div class="offline-selector">
              <div class="online-label">Online</div>
              <mat-slide-toggle [(ngModel)]="isOffline" (change)="offlineChanged()">Offline</mat-slide-toggle>
            </div>
            <div><small>
              <mat-checkbox [(ngModel)]="detectOffline" (change)="detectChanged()">Detect when offline</mat-checkbox>
            </small></div>
          </div>
        }
      </mat-sidenav>

      <mat-sidenav-content class="pm-main-content" [class.isTemplate]="isTemplate$ | async">
        <pm-process-tree class="pm-process-tree" [domain]="domain$ | async" [tree]="tree$ | async" [isAuthor]="isAuthor$ | async"
        [openRows]="openRows$ | async" [nodeActivation]="nodeActivation$| async"></pm-process-tree>
        @if (isTemplate$ | async) {
          <div class="pm-template-watermark">{{'watermark.template' | translate}}</div>
        }
        @if ((online | async) && !(isTemplate$ | async) && (isTrial || isQuoteTrial)) {
          <div class="pm-trial-watermark">{{'watermark.trial' | translate}}</div>
        }
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
